import { OfflineStorage } from "./estrylib";

export const ResidenceAppointmentsTypesButtonsItems = [
  {
    id: 1,
    text: "First Time",
  },
  {
    id: 2,
    text: "Renewal",
  },
];
export const ResidenceAppointmentsVerificationButtonsItems = [
  {
    id: 1,
    text: "Email",
  },
  {
    id: 2,
    text: "Phone",
  },
];
export const ResidenceAppointmentTypes = [
  {
    label: window.sys_app_translate(
      "Tourism",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: "Tourism",
  },
];
